// Components==============
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/UI/Avatar/Avatar';
import Tippy from 'components/UI/Tooltip/Tippy';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import TooltipContextWrapper from 'components/UI/Tooltip/TooltipContextWrapper';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { NavLink } from 'react-router-dom';
import './TopNav.module.scss';
// =========================

export default function TopNav({ user }: { user?: UserEntity }) {
  const translate = useTranslate();

  return (
    <TooltipContextWrapper>
      <Tippy />
      <div styleName="wrapper">
        <NavLink to="/" styleName="logo">
          <img src="/images/Groow-logo.svg" alt="groow-logo" />
        </NavLink>
        <div styleName="right">
          <Tooltip
            content={<p>{translate('general.support.tooltip')}</p>}
            position="bottom"
          >
            <a href="mailto:groow@studiotast.com" styleName="icon left">
              <FontAwesomeIcon icon={faQuestionCircle} />
            </a>
          </Tooltip>
          <div styleName="icon large left">
            <div styleName="user">
              <Avatar user={user} />
              <div styleName="user-info">
                <p>{`${user?.first_name} ${user?.last_name}`}</p>
                <p>
                  {user?.roles[0].name === 'Docent'
                    ? 'Groown-up'
                    : user?.roles[0].name === 'super-admin'
                    ? 'God of growth'
                    : user?.roles[0].name}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TooltipContextWrapper>
  );
}
